import { usePopup } from "hooks/usePopup";
import { useSoundPath } from "hooks/useSoundPath";

const PageHeaderAddFunds = () => {
  const setPopupHook = usePopup();
  const playSound = useSoundPath();

  return (
    <>
      <button
        className="page-header__user-popup-action"
        onClick={() => {
          playSound("main");
          setPopupHook({type: 'add-funds'});
        }}
      >
        Add Funds
      </button>
    </>
  );
};

export default PageHeaderAddFunds;
